<section class="home-resume-banner">
  <div class="banner-content">
    <span class="banner-badge">{{ 'resume_examples_banner.new' | translate }}</span>

    <h2>{{ 'resume_examples_banner.resume_examples' | translate }}</h2>

    <p class="banner-subtitle">
      {{ 'resume_examples_banner.explore_resume_examples' | translate }}
    </p>

    <ul class="banner-features">
      <li> {{ 'resume_examples_banner.all_professions' | translate }}</li>
      <li>{{ 'resume_examples_banner.edit_online' | translate }}</li>
      <li>{{ 'resume_examples_banner.PDF_download' | translate }}</li>
      <li>{{ 'resume_examples_banner.ATS_friendly' | translate }}</li>
    </ul>

    <div class="banner-actions">
      <a class="sf-btn-primary" routerLink="/resume-examples/">
        {{ 'resume_examples_banner.browse_resume' | translate }}
      </a>

      @let myRoute = appStateService.isAuthenticated ?
        (appStateService.route_paths | lngRoute: 'dashboard' : appStateService.dateTime) :
        (appStateService.route_paths | lngRoute: 'cv_templates' : appStateService.dateTime);

      <a class="sf-btn-fifth" [routerLink]="myRoute">
        {{ 'resume_examples_banner.create_resume' | translate }}
      </a>
    </div>
  </div>

  <div class="banner-visual">
    <img
      src="/assets/img/template-covers/tm-2/color-2-sidebar-page-1.png"
      alt="Resume examples by profession on selfcv"
      loading="lazy"
    />
  </div>
</section>

